import ClassNames from 'classnames'
import React from 'react'
import {
  Grid,
  Section
} from './../../../../components'
import {
  WarrantyCladdingIssuesListsWrapper
} from './styled'

export class WarrantyBSWMThailandCladdingIssuesLists extends React.PureComponent {
  render() {
    const {
      thLanguage,
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'warranty-bswm-note',
    )

    return (
      <WarrantyCladdingIssuesListsWrapper
        className={classes}
      >
        {thLanguage ?
          <React.Fragment>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>ก.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>แผ่นเหล็กต้องแห้งเสมอในขณะที่เรียงซ้อนกันก่อนการติดตั้ง แผ่นเหล็กที่เปียกควรถูกแยกออกและทำให้แห้งเพื่อลดความเสี่ยงต่อการกัดกร่อนเร็วขึ้น<br />เนื่องจาก “ความเปียกในขณะเรียงซ้อนกัน”</p></Grid.Column>
            </Grid>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>ข.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>ห้ามตัดแผ่นเหล็กด้วยเครื่องตัดชนิดจานใบเลื่อยหรือเครื่องขัด เนื่องจากเศษโลหะที่มีอุณภูมิสูงจะทำลายชั้นเคลือบ</p></Grid.Column>
            </Grid>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>ค.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>ในระหว่างการติดตั้ง ให้ทำความสะอาดเศษโลหะและเศษวัสดุอื่นๆ ออกทุกวันเพื่อลดความเสี่ยงต่อการกัดกร่อน</p></Grid.Column>
            </Grid>
          </React.Fragment>
          :
          <React.Fragment>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>a.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>Keep sheet dry at all times while stacked in bundles prior to installation. Wet sheet should be separated and dried to minimize risk of accelerated corrosion due to “wet stacking”.</p></Grid.Column>
            </Grid>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>b.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>Do not cut sheet by circular saw or grinders as high temperature swarf will damage the coating.</p></Grid.Column>
            </Grid>
            <Grid>
              <Grid.Column flex='none'><Section width='17'><p className='warranty-bswm-text is-xs'>c.</p></Section></Grid.Column>
              <Grid.Column flex='1'><p className='warranty-bswm-text is-xs'>During construction, remove swarf and other debris daily to minimize risk of localized corrosion.</p></Grid.Column>
            </Grid>
          </React.Fragment>
        }
      </WarrantyCladdingIssuesListsWrapper>
    )
  }

  static defaultProps = {
    // If you set new default props, you should create propsType for correct styleguide document.
  }

  static propTypes = {
    // TYPE > node, string, number, bool, array, object, symbol, func
  }
}
